export default "__VITE_ASSET__DLQEEWwP__"